import { render } from "./WeeklyReport.vue?vue&type=template&id=f8b134c8&scoped=true"
import script from "./WeeklyReport.vue?vue&type=script&lang=js"
export * from "./WeeklyReport.vue?vue&type=script&lang=js"

import "./WeeklyReport.vue?vue&type=style&index=0&id=f8b134c8&scoped=true&lang=css"

import exportComponent from "/var/www/html/dongan_teens2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8b134c8"]])

export default __exports__